











































































































































import { Component, Mixins, Prop } from 'vue-property-decorator';
import { ENumberInputType } from '@lib-shared/editor/types/enums';
import PricingTableDescriptionInput from '@/editor/editor-block-view/components/pricing-table/PricingTableDescriptionInput.vue';
import { PricingTableHelper } from '@lib-shared/editor/helpers/pricing-table.helper';
import PricingTableRowRoot from '@lib-shared/editor/mixins/pricing-table-row-root';

@Component({
  components: {
    PricingTableDescriptionInput,
  },
  data: () => ({
    ENumberInputType,
  }),
})
export default class PricingTableRow extends Mixins(PricingTableRowRoot) {
  @Prop() isBlockWidthSmall: boolean;

  get showDescription(): boolean {
    return !this.descriptionIsEmpty;
  }

  get showSku(): boolean {
    return !this.skuIsEmpty;
  }

  get discountedPrice(): string {
    return PricingTableHelper.currencyFormat(this.netPrice, this.currencySettings);
  }

  get showDiscount(): boolean {
    return this.discountEnabled && !this.discountIsEmpty;
  }

  formatPrice(price: string): string {
    const value = price === '' ? '0' : price;
    return PricingTableHelper.currencyFormat(value, this.currencySettings);
  }

  formatNumber(inputValue: string, type: ENumberInputType): string {
    const value = inputValue === '' ? '0' : inputValue;
    switch (type) {
      case ENumberInputType.Number:
        return value;

      case ENumberInputType.Text:
        return value;

      case ENumberInputType.Percentage:
        return `${value}%`;

      case ENumberInputType.Currency:
        return PricingTableHelper.currencyFormat(value, this.currencySettings);

      default:
        return value;
    }
  }
}
